import { Colors } from '@ab-core/colors';
import { FontTypes } from '@ab-core/font-types';
import { FormElementHeight } from '@ab-core/forms';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const StyledPositionTextContainer = styled.div`
    display: flex;
    height: ${FormElementHeight.Normal};
    align-items: center;
`;

export const LinkText = styled.div`
    color: ${Colors.primary};
    font-size: ${FontTypes.body.fontSize};
    font-weight: ${FontTypes.body.fontWeight};
    text-decoration: underline;

    cursor: pointer;
    display: flex;
    gap: ${SPACING.SMALL_2};
`;

export const InputWrapper = styled.div`
    flex-grow: 1;
`;
